import React, { useState } from "react";
import { Polling, PollingToken } from "./Polling";

import { Scanner } from "./Scanner";
import { RouteProp } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { LoginNavigationParamList } from "@/src/OS/Login/navigation";

export function GroupDeviceLoginScreen(props: {
  navigation: NativeStackNavigationProp<
    LoginNavigationParamList,
    "GroupDeviceLogin"
  >;
  route: RouteProp<LoginNavigationParamList, "GroupDeviceLogin">;
}) {
  const [pollToken, setPollingToken] = useState<PollingToken | null>(null);

  if (pollToken) {
    return (
      <Polling
        pollToken={pollToken}
        onError={() => {
          setPollingToken(null);
        }}
      />
    );
  }
  return <Scanner onPollToken={setPollingToken} />;
}
